module.exports = "/_next/static/images/399342731b5f48bf8efd6d954ecb249f-press-hero.jpg";